<template>
  <div
    class="header d-flex justify-content-between align-items-center"
    :class="{ 'is-opened': isOpened }"
  >
    <div class="header__wrap">
      <div class="header__content">
        <div class="header__left">
          <h1 class="header__title">{{ title }}</h1>
          <div class="header__subheading" v-if="subheading">
            {{ subheading }}
          </div>
          <treeselect
            v-if="select"
            class="vue-treeselect--w35 ml-4"
            v-model="selectedDictionary"
            placeholder="Wybierz słownik"
            :multiple="false"
            :options="DictionaryMenu"
            :clearable="false"
            @input="$emit('changeRoute', selectedDictionary)"
          />
        </div>
        <div class="header__language-switcher">
          <language-switcher
            :key="$route.params.id"
            v-if="
              !hideLanguageSwitcher.includes($route.name) &&
                !hideLanguageSwitcher.includes($route.meta.submenu)
            "
          ></language-switcher>
          <img class="header__logo" src="../../img/cellfast-logo.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitcher from "@/components/parts/LanguageSwitcher";
import Treeselect from "@riophae/vue-treeselect";

export default {
  data() {
    return {
      hideLanguageSwitcher: [
        "activity",
        "files",
        "productEdit",
        "dictionariesLanguages",
        "dictionariesSpimCategories",
      ],
      isOpened: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.label,
        };
      },
    };
  },
  props: {
    title: {
      type: String,
      require: true,
    },
    subheading: {
      type: String,
      require: false,
    },
    select: {
      type: Boolean,
      require: true,
    },
    selectedDictionary: {
      type: String,
      require: false,
    },
    DictionaryMenu: {
      type: Array,
      require: false,
    },
  },
  components: {
    LanguageSwitcher,
    Treeselect,
  },
};
</script>
